// extracted by mini-css-extract-plugin
export default {"image_block":"styles_image_block__AP9vM","text_block":"styles_text_block__gxJNd"};